import TYPES from '../../types';

// Domain
import {
  ReferrerTypeEntity,
} from '../../domain/entities/referrer-type-entity';
import { ReferrerTypeRepository } from '../../domain/repositories/referrer-type-repository';
import { StateManager } from '../../domain/state/state-manager';
import Query from '@/modules/shared/domain/use-cases/query';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';

@Injectable()
export default class GetAllReferrerTypesQuery extends Query<Promise<Array<ReferrerTypeEntity>>> {
  @Inject(TYPES.REFERRER_TYPES_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.REFERRER_TYPES_REPOSITORY)
  private readonly repository!: ReferrerTypeRepository;

  internalExecute(): Promise<Array<ReferrerTypeEntity>> {
    return new Promise((resolve, reject) => {
      if (this.state_manager.state.loaded) {
        resolve(this.state_manager.state.items);
      } else {
        this.repository.get()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      }
    });
  }
}
